export default __webpack_public_path__ + "static/media/profile.8ff01c16.png";